// extracted by mini-css-extract-plugin
export var labelWrapper = "_m5-0";